import React from "react";

export const TopUp = () => {
  return (
    <div className="py-4 px-4 font-semibold ">
      <p>Your wallet in Ajebuta will be credited with AjCoin.</p>
    </div>
  );
};
